export default __webpack_public_path__ + "static/media/banner-I.84694364.jpg";